import styled from "styled-components";

export const IndexDashboardImageComponentMainDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const IndexDashboardImageComponentContaner = styled.div`
  flex: 1;

  .window-frame {
    width: 100%;
    min-width: 400px;
    max-width: 1140px;
    height: 539px;
    background: rgba(0, 0, 0, 1);
    border-radius: 18px;
    display: flex;
  }
  .sidebar {
    border: 1px solid #322c29;
    border-radius: 18px;
    width: 24%;
    max-width: 300px;
    min-width: 250px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: var(--size-2);
  }
  .modal-header-holder {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .close-modal {
    display: flex;
    gap: 6px;
    div {
      width: 12px;
      height: 12px;
      background-color: red;
      border-radius: 1000px;
    }
    :nth-child(1) {
      background-color: #f95a5b;
    }
    :nth-child(2) {
      background-color: #f4c101;
    }
    :nth-child(3) {
      background-color: #37c156;
    }
  }
  .dashboard-logo-header {
    padding: 16px 0px 8px 2px;

    display: flex;
    align-items: Center;
    gap: 4px;
  }
  .dashboard-logo-holder {
    width: 32px;
    height: 32px;
  }
  .header-text {
    h4 {
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
      white-space: pre;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.2em;
      padding: 0;
      margin: 0;
      text-transform: capitalize;
    }
  }

  .dashboard-new-chat-button {
    width: 90%;
    border: 1px solid #322c29;
    padding: 8px;
    border-radius: 8px;

    font-family: "General Sans", "General Sans Placeholder", sans-serif;
    white-space: pre;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2em;
    text-transform: capitalize;
    > div {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;

      gap: 8px;
      align-items: center;
    }
    .new-icon-holder {
      width: 20px;
      height: 20px;
    }
    .small {
      width: 20px;
      height: 20px;
    }
  }
  .icon-medium {
    width: 24px;
    height: 24px;
  }
  .chat-history-modal {
    display: flex;
    flex-direction: column;
    gap:var(--size-2);

    .chat-modal {
      display: flex;
      align-items: center;
      gap: 8px;
      
    }
  }
    .chat-modal-text {
        font-size: 16px;
        padding: 0;
        font-weight:400;
        margin: 0;
        text-transform:capitalize;
      }
  .chat-modal-icon-holder {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
